import { makeStyles } from '@material-ui/styles';

export const makeFooterStyles = makeStyles({
  expansionPanelSummary: {
    '&.Mui-expanded': {
      '& .line-horizontal': {
        transform: 'rotate(180deg)',
        opacity: 0,
      },

      '& .line-vertical': {
        transform: 'rotate(270deg)',
      },
    },
  },

  plusIcon: {
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    height: '14px',
    justifyContent: 'center',
    margin: 'auto',
    position: 'absolute',
    right: 0,
    top: '14px',
    width: '14px',

    '& .line-horizontal': {
      border: `1px solid #a5a5a5`,
      position: 'absolute',
      transition: `all 0.3s ease`,
      width: '100%',
    },

    '& .line-vertical': {
      border: `1px solid #a5a5a5`,
      height: '100%',
      position: 'absolute',
      transition: `all 0.3s ease`,
    },
  },
}, { index: 1, });
